import { render, staticRenderFns } from "./GlobalRealtyBusinessCard.vue?vue&type=template&id=8c3de5cc&scoped=true&"
import script from "./GlobalRealtyBusinessCard.vue?vue&type=script&lang=js&"
export * from "./GlobalRealtyBusinessCard.vue?vue&type=script&lang=js&"
import style0 from "./GlobalRealtyBusinessCard.vue?vue&type=style&index=0&id=8c3de5cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3de5cc",
  null
  
)

export default component.exports